import da from '../assets/icons/flags/da.svg';
import de from '../assets/icons/flags/de.svg';
import no from '../assets/icons/flags/no.svg';
import pl from '../assets/icons/flags/pl.svg';
import sv from '../assets/icons/flags/sv.svg';
import uk from '../assets/icons/flags/uk.svg';

export interface ISingleFlag {
  id: string;
  flagName: string;
  shortName: string;
  shortDisplayName: string;
  name: string;
  icon: any;
}

export interface IFlagList {
  en: ISingleFlag;
  no: ISingleFlag;
  nb: ISingleFlag;
  sv: ISingleFlag;
}

export const flagsArray = [
  {
    id: '1',
    name: 'English',
    shortName: 'en',
    icon: uk,
  },
  {
    id: '2',
    name: 'Norsk',
    shortName: 'no',
    icon: no,
  },
  {
    id: '3',
    name: 'Polish',
    shortName: 'pl',
    icon: pl,
  },
  {
    id: '4',
    name: 'Deutsch',
    shortName: 'de',
    icon: de,
  },
  {
    id: '5',
    name: 'Svensk',
    shortName: 'sv',
    icon: sv,
  },
  {
    id: '6',
    name: 'Dansk',
    shortName: 'da',
    icon: da,
  },
];

export const langMenuDropArr = [
  {
    id: 'fl1',
    flagName: 'English',
    name: 'English',
    shortName: 'en',
    shortDisplayName: 'eng',
    icon: uk,
  },
  {
    id: 'fl2',
    flagName: 'Norwegian',
    name: 'Norsk',
    shortName: 'nb',
    shortDisplayName: 'nor',
    icon: no,
  },
  {
    id: 'fl5',
    flagName: 'Swedish',
    name: 'Svenska',
    shortName: 'sv',
    shortDisplayName: 'swe',
    icon: sv,
  },
  {
    id: 'fl6',
    flagName: 'Danish',
    name: 'Dansk',
    shortName: 'da',
    shortDisplayName: 'dan',
    icon: da,
  },
];
